import { render, staticRenderFns } from "./ContactText.vue?vue&type=template&id=e458d972&scoped=true&lang=html&"
import script from "./ContactText.vue?vue&type=script&lang=js&"
export * from "./ContactText.vue?vue&type=script&lang=js&"
import style0 from "./ContactText.vue?vue&type=style&index=0&id=e458d972&prod&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e458d972",
  null
  
)

export default component.exports